import {
  QueryFunctionContext,
  useInfiniteQuery,
  QueryKey,
} from "@tanstack/react-query";

import { PaginationClientInfoModel } from "../api/v1";

import { BASE_QUERY_KEY } from "./constants";

export interface PaginatedResponseModel<T> {
  data: Array<T>;
  pagination: PaginationClientInfoModel;
}

export const DEFAULT_LIST_LIMIT = 50;

export default function useListQuery<T>({
  fetchMethod,
  queryKey,
  initialOffset = 0,
  refetch,
  enabled,
}: {
  fetchMethod: (
    params: QueryFunctionContext,
  ) => Promise<PaginatedResponseModel<T>>;
  queryKey: QueryKey;
  initialOffset?: number;
  refetch?: number;
  enabled?: boolean;
}) {
  return useInfiniteQuery([BASE_QUERY_KEY, ...queryKey], fetchMethod, {
    getNextPageParam: (lastPage) => {
      const skip = lastPage.pagination.offset + lastPage.pagination.limit;
      return skip >= (lastPage.pagination.total || 0) ? undefined : skip;
    },
    getPreviousPageParam: (firstPage) => {
      const skip = firstPage.pagination.offset - firstPage.pagination.limit;
      return skip <= 0 ? undefined : skip;
    },
    initialData: {
      pages: [
        {
          data: [],
          pagination: {
            limit: DEFAULT_LIST_LIMIT,
            offset: initialOffset,
            total: 0,
          },
        },
      ],
      pageParams: [initialOffset],
    },
    keepPreviousData: true,
    refetchInterval: refetch,
    enabled,
  });
}
